// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".message[data-v-1cca0f7a] {\n  font-weight: normal;\n  color: white;\n  -moz-border-radius: 10px 10px 10px 10px;\n  -webkit-border-radius: 10px 10px 10px 10px;\n}[dir] .message[data-v-1cca0f7a] {\n  background: #ea7037;\n  border-radius: 10px 10px 10px 10px;\n  border: 0px solid #000000;\n  padding: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
